<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    @close="onClose"
    width="600px">
    <el-table :data="table"
              stripe
              highlight-current-row
              border>

      <el-table-column label="ID"
                       prop="id"></el-table-column>
      <el-table-column label="添加日期"
                       prop="created_at"></el-table-column>

      <el-table-column fixed="right"
                       label="操作"
                       width="75">
        <template slot-scope="scope">
          <button-gutter>
            <el-button size="mini"
                       type="primary"
                       @click="readCache(scope.row.id)">查看
            </el-button>
          </button-gutter>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="margin t10"
                   background
                   @current-change="handleCurrentPageChange"
                   :current-page="pagination.current_page"
                   :page-size="pagination.per_page"
                   layout="total, prev, pager, next"
                   :total="pagination.total">
    </el-pagination>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleAction('cancel')">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { conveSomeDataType, setParams } from '@core/mixins/table'

export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,
      action: '',
      title: '工单审核历史记录',
      table: [],
      pagination: {
        current_page: 1,
        per_page: 3,
        total: 0,
      },
      // 入参与出参
      orderId: 0,
      callbackData: null
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    handleAction (action) {
      this.action = action
      this.doClose()
    },
    onClose () {
      if (!this.visible) return
      this.handleAction('close')
    },
    doClose () {
      if (!this.visible) return
      this.visible = false
      setTimeout(() => {
        if (this.action) this.callback(this.action, this)
      })
    },
    /**
     * 获得表格数据
     */
    getTableData () {
      return request.alert('getOrderReviewHistoryTable', {
        orderid: this.orderId,
        ...this.pagination,
      })
    },
    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData ({data}) {
      this.$set(this, 'table', data.data)
      this.setPagination(data)
    },
    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination (pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination)
      // 设置参数
      setParams(this.pagination, pagination)
    },
    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange (val) {
      this.setPagination({per_page: val})
      this.getTableData().then(this.setTableData)
    },
    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange (val) {
      this.setPagination({current_page: val})
      this.getTableData().then(this.setTableData)
    },
    /**
     * 读取缓存到审核页面
     */
    readCache (id) {
      this.$confirm('确认显示该历史审核记录吗？', '提示', {type: 'warning'}).then(() => {
        request.common('getOrderReviewHistoryDetail', {id}).then(({data}) => {
          this.callbackData = data
          this.handleAction('confirm')
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/order-review-history-box/src/main.vue